import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import InfoBlock from './InfoBlock';
import LinksBlock from './LinksBlock';
import CustomHtml from './CustomHtml';
import BottomBar from './BottomBar';
export default class CustomFooter extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.displayMode = parseInt(app.forum.attribute('modern-footer.display-mode'));
    this.visibility = app.forum.attribute('modern-footer.visibility') || 'both';
  }
  oncreate() {
    const customJS = app.forum.attribute('modern-footer.js');
    if (customJS) {
      const scriptElement = document.createRange().createContextualFragment(customJS);
      document.body.appendChild(scriptElement);
    }
    const rawMobileTabHeight = app.forum.attribute('modern-footer.mobile-tab') || '0px';
    // Sadece geçerli CSS uzunluk değerlerine ve var(--...) ifadelerine izin ver;
    // { } ; < > gibi karakterleri reddederek CSS/HTML injection'ı engelle.
    const isValidCssLength = /^\d+(\.\d+)?(px|rem|em|vh|vw|%)$/.test(rawMobileTabHeight);
    const isValidCssVar = /^var\(--[a-zA-Z0-9-]+(\s*,\s*\d+(\.\d+)?(px|rem|em|vh|vw|%)?)?\)$/.test(rawMobileTabHeight);
    const mobileTabHeight = isValidCssLength || isValidCssVar ? rawMobileTabHeight : '0px';
    const style = document.createElement('style');
    style.innerHTML = "\n      @media (max-width: 768px) {\n        #modern-footer>div {\n          margin-bottom: ".concat(mobileTabHeight, ";\n        }\n      }\n    ");
    document.head.appendChild(style);
  }
  view() {
    // Önce sayfa kontrolü
    const showFooter = this.shouldShowFooter(this.displayMode);
    if (!showFooter) {
      return null;
    }

    // Sonra görünürlük kontrolü
    if (!this.checkVisibility()) {
      return null;
    }
    return m("div", null, m("div", {
      class: "row"
    }, app.forum.attribute('modern-footer.info-enabled') && m(InfoBlock, null), app.forum.attribute('modern-footer.links-1-enabled') && m(LinksBlock, {
      title: app.forum.attribute('modern-footer.title-2'),
      start: 1,
      end: 6,
      iconClass: app.forum.attribute('modern-footer.title-fa-2')
    }), app.forum.attribute('modern-footer.links-2-enabled') && m(LinksBlock, {
      title: app.forum.attribute('modern-footer.title-3'),
      start: 7,
      end: 12,
      iconClass: app.forum.attribute('modern-footer.title-fa-3')
    }), app.forum.attribute('modern-footer.links-3-enabled') && m(LinksBlock, {
      title: app.forum.attribute('modern-footer.title-4'),
      start: 13,
      end: 18,
      iconClass: app.forum.attribute('modern-footer.title-fa-4')
    }), app.forum.attribute('modern-footer.links-4-enabled') && m(LinksBlock, {
      title: app.forum.attribute('modern-footer.title-5'),
      start: 19,
      end: 24,
      iconClass: app.forum.attribute('modern-footer.title-fa-5')
    })), m(CustomHtml, null), m(BottomBar, null));
  }
  shouldShowFooter(displayMode) {
    const routeName = app.current.get('routeName');
    const mainRoute = routeName ? routeName.split('.')[0] : '';
    if (routeName === 'notifications' || routeName === 'flags' || routeName === 'drafts') {
      return false;
    }
    const displayModeMap = {
      0: true,
      1: false,
      2: mainRoute !== 'discussion',
      3: mainRoute === 'index',
      4: true
    };
    return displayModeMap[displayMode] !== undefined ? displayModeMap[displayMode] : true;
  }
  checkVisibility() {
    const isLoggedIn = !!app.session.user;
    switch (this.visibility) {
      case 'members':
        return isLoggedIn;
      case 'guests':
        return !isLoggedIn;
      case 'both':
      default:
        return true;
    }
  }
}
flarum.reg.add('huseyinfiliz-modern-footer', 'forum/components/CustomFooter', CustomFooter);